export default __webpack_public_path__ + "static/media/icon_fondos_selected.92af04ed.svg";